import React from 'react';
import { Helmet } from 'react-helmet';
import LandingPage from './unAuth/LandingPage';
import './App.css';
import './firebase';

function App() {
  return (
    <div className="App">
      <Helmet>
        <meta name="description" content="Instantly generate detailed timestamps for any YouTube video by simply pasting its URL—organize, share, and highlight key moments faster." />
        <meta name="keywords" content="YouTube timestamps, video timestamps, timestamp generator, YouTube video organization, video chaptering, timestamp links, YouTube video highlights, video navigation, timestamp creation tool, YouTube video management" />
        <meta name="author" content="Stamp Sage" />
      </Helmet>
      <LandingPage />
    </div>
  );
}

export default App;